export default __webpack_public_path__ + "static/endless-waves-poster-bdf196de13a90f156db38a359a4a9272.jpg";